import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { ClockRegular } from "@fluentui/react-icons";
import { format, startOfMinute } from "date-fns";
import React, { useEffect } from "react";
import { getConvertedTime } from "../../../utils/common/DateHelperFunctions";
import { Timezone } from "../layout/Layout";

export interface ITimeDisplayProps {
  currentTime: Date;
  setCurrentTime: React.Dispatch<React.SetStateAction<Date>>;
  timezone: Timezone;
  airportTimeZone: string;
}

const TimeDisplay: React.FC<ITimeDisplayProps> = ({
  currentTime,
  setCurrentTime,
  timezone,
  airportTimeZone,
}) => {
  const classes = useStyles();

  const formattedTime = format(currentTime, "HH:mm");
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const convertedTime = startOfMinute(
        getConvertedTime(now, timezone, airportTimeZone)
      );
      setCurrentTime(convertedTime);
    };
    updateTime();
    const intervalId = setInterval(updateTime, 60000); // Update every minute

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, [timezone, airportTimeZone]);

  return (
    <div
      className={mergeClasses(
        classes.timeContainer,
        "amd-container-vcenter",
        "fs-16",
        "fw-500"
      )}
      data-testid="time-display"
    >
      <ClockRegular aria-label="A clock in HH:mm format" />
      {formattedTime}
    </div>
  );
};

export default TimeDisplay;

const useStyles = makeStyles({
  timeContainer: {
    color: "#333",
    padding: "0px 10px",
    textAlign: "center",
    gap: "5px",
  },
});
